import { GET_PARTNER_REDEMPTIONS } from "../gql/partner";
import { ApolloClientPartnerService } from "../services/ApolloClientPartnerService";

export const getPartnerRedemptions = async (input, dispatch) => {
  try {
    const { data } = await ApolloClientPartnerService.query({
      query: GET_PARTNER_REDEMPTIONS,
      operationName: "GET_PARTNER_REDEMPTIONS",
      variables: { input },
      fetchPolicy: "network-only",
    });
    const response = data?.getPartnerRedemptions || {};
    return response;
  } catch (err) {
    return err;
  }
};
